const configlive = {
    mode: "live",
    web_url: "https://markii.gdq.se",
    front_url: "https://markii.gdq.se",
    admin_url: "https://admin.gdq.se",
    enterprise_url: "https://enterprise.gdq.se",
    base_url: "https://api.gdq.se",
    report_url: "https://reports.gdq.se",
    api_token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk",
};
const configtest = {
    mode: "test",
    web_url: "http://localhost:8080",
    front_url: "http://localhost:8080",
    admin_url: "http://localhost:8081",
    enterprise_url: "http://localhost:8082",
    base_url: "http://ubuntu-prodesk.local/gdq_api",
    report_url: "http://ubuntu-prodesk.local/gdq_reports",
    api_token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk",
};
const configstage = {
    mode: "stage",
    web_url: "https://markii.test.gdq.se",
    front_url: "https://markii.test.gdq.se",
    admin_url: "https://admin.test.gdq.se",
    enterprise_url: "https://enterprise.test.gdq.se",
    base_url: "https://api.test.gdq.se",
    report_url: "https://reports.test.gdq.se",
    api_token:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MCwiZXhwIjoxNzkzNjk5MzEyfQ.RN9RffkIpmOrKsAjCyP6cmhPRLtzPzzXgRNzvVcxugk",
};
let config = configlive;
const location = window.location;

if (location.host.indexOf(".test.gdq.se") > 0) {
    config = configstage;
}
if (location.host.indexOf("gdq.se") < 0) {
    config = configtest;
    if (location.port !== "") {
        const origin = location.protocol + "//" + location.hostname;
        config = {
            ...configtest,
            web_url: origin + ":8080",
            front_url: origin + ":8080",
            admin_url: origin + ":8081",
            enterprise_url: origin + ":8082",
        };
    }
}
export { config };
